import { connect } from 'react-redux';
import AccountWrapper from './AccountWrapper';
import { isLoading, isLocked, isNotProvided, isMissingWeb3 } from '../selectors/account';
import {
  accountWalletReset,
  accountWalletSelect,
  accountTosAccept,
  accountIntroComplete,
  accountRefresh,
  walletIsSupported,
} from '../actions/account';

const mapStateToProps = (state, ownProps) => ({
  currentAddress: state.account.address,
  detectedNetwork: state.account.network,
  expectedNetwork: ownProps.networkName,
  wrongNetwork: !!(state.account.network && state.account.network !== ownProps.networkName),
  isLoading: isLoading(state),
  isLocked: isLocked(state),
  isMissingWeb3: isMissingWeb3(state),
  isNotProvided: isNotProvided(state),
  tosAccepted: state.account.tosAccepted,
  walletType: state.account.walletType,
  introCompleted: state.account.introCompleted,
  isWalletReloading: state.account.isWalletReloading,
});

const mapDispatchToProps = dispatch => ({
  onTosAccept: () => dispatch(accountTosAccept()),
  onWalletReset: () => dispatch(accountWalletReset()),
  onWalletSelect: (walletType, walletOptions) => {
    dispatch(accountWalletSelect(walletType, walletOptions));
  },
  onIntroComplete: () => dispatch(accountIntroComplete()),
  onAccountRefresh: () => dispatch(accountRefresh()),
  onWalletIsSupported: (walletType, givenProvider) =>
    dispatch(walletIsSupported(walletType, givenProvider)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountWrapper);



// WEBPACK FOOTER //
// ./src/components/AccountWrapperContainer.js